import request from 'utils/request';

export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;

export function getDiningOptionsRequest(storeUuid, options = {}) {
  return request(`${API_BASE_URL}/v1/stores/${storeUuid}/order-types/`, {
    method: 'GET',
    ...options,
  });
}

export function getDiningOptionDetailRequest({ storeUuid, diningOptionUuid }, options = {}) {
  return request(`${API_BASE_URL}/v1/stores/${storeUuid}/order-types/${diningOptionUuid}/`, {
    method: 'GET',
    ...options,
  });
}

export function createDiningOptionRequest({ storeUuid, diningOption }, options = {}) {
  return request(`${API_BASE_URL}/v1/stores/${storeUuid}/order-types/`, {
    method: 'POST',
    body: JSON.stringify(diningOption),
    ...options,
  });
}

export function deleteDiningOptionRequest({ storeUuid, diningOptionUuid }, options = {}) {
  return request(`${API_BASE_URL}/v1/stores/${storeUuid}/order-types/${diningOptionUuid}/`, {
    method: 'DELETE',
    ...options,
  });
}

export function setIsEnabledDiningOptionRequest({ storeUuid, diningOptionUuid, isEnabled }, options = {}) {
  return request(`${API_BASE_URL}/v1/stores/${storeUuid}/order-types/${diningOptionUuid}/set-is-enabled/`, {
    method: 'PUT',
    body: JSON.stringify({
      is_enabled: isEnabled,
    }),
    ...options,
  });
}

export function editDiningOptionRequest({ storeUuid, diningOptionUuid, diningOption }, options = {}) {
  return request(`${API_BASE_URL}/v1/stores/${storeUuid}/order-types/${diningOptionUuid}/`, {
    method: 'PUT',
    body: JSON.stringify(diningOption),
    ...options,
  });
}

export function setIsDefaultDiningOptionRequest({ storeUuid, diningOptionUuid, isDefault }, options = {}) {
  return request(`${API_BASE_URL}/v1/stores/${storeUuid}/order-types/${diningOptionUuid}/set-is-default/`, {
    method: 'PUT',
    body: JSON.stringify({
      is_default: isDefault,
    }),
    ...options,
  });
}
